import { useThemeVariant } from "@/contexts/ThemeContext";
import { useReviewsModel } from "@/components/home/layouts/models";
import { ClassicReviews } from "@/components/home/layouts/classic";
import { MinimalReviews } from "@/components/home/layouts/minimal";
import { WarmReviews } from "@/components/home/layouts/warm";
import { BoldReviews } from "@/components/home/layouts/bold";
import { ElegantReviews } from "@/components/home/layouts/elegant";
import { FreshReviews } from "@/components/home/layouts/fresh";
import { ModernReviews } from "@/components/home/layouts/modern";

interface TestimonialsProps {
  /**
   * Where "Leave a review" should point — only passed when the page actually
   * has a "Leave a review" block (page builder). Omitted → no link.
   */
  reviewFormHref?: string;
}

/**
 * Approved customer reviews with a rating summary. Collecting new reviews is a
 * separate, optional page-builder block ("Leave a review"), so this section is
 * display-only. Presentation follows the theme preset.
 */
export function Testimonials({ reviewFormHref }: TestimonialsProps) {
  const r = useReviewsModel();
  switch (useThemeVariant()) {
    case "modern-minimal": return <MinimalReviews r={r} reviewFormHref={reviewFormHref} />;
    case "warm-welcome": return <WarmReviews r={r} reviewFormHref={reviewFormHref} />;
    case "bold-vibrant": return <BoldReviews r={r} reviewFormHref={reviewFormHref} />;
    case "elegant-serif": return <ElegantReviews r={r} reviewFormHref={reviewFormHref} />;
    case "fresh-natural": return <FreshReviews r={r} reviewFormHref={reviewFormHref} />;
    case "modern": return <ModernReviews r={r} reviewFormHref={reviewFormHref} />;
    default: return <ClassicReviews r={r} reviewFormHref={reviewFormHref} />;
  }
}
